import normalizePhoneNumber from './normalizePhoneNumber'

export default (value: string): boolean => {
  try {
    return !!normalizePhoneNumber(value)
  } catch (e) {
    return false
  }
}
